import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/ios")({
  component: IOSPage,
  head: () => ({
    meta: [
      {
        property: "og:title",
        content: "Macrowave on iOS - Broadcast and Listen Anywhere",
      },
      {
        property: "og:description",
        content:
          "Create radio stations and tune in from your iPhone. Broadcast on-the-go or listen to your favorite stations.",
      },
      {
        name: "description",
        content:
          "Create radio stations and tune in from your iPhone. Broadcast on-the-go or listen to your favorite stations.",
      },
    ],
  }),
});

function IOSPage() {
  return (
    <div className="mx-auto max-w-4xl py-12 px-6">
      {/* Hero Section */}
      <div className="text-center mb-16">
        <h1 className="font-serif-600 text-4xl text-black mb-4">
          Macrowave on iOS
        </h1>
        <p className="font-serif text-xl text-gray-700 mb-8">
          Broadcast your world or tune into stations — all from your iPhone.
        </p>
        <a
          href="https://apps.apple.com/app/macrowave/id6738969244"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block"
        >
          <img
            src="/images/app-store-badge.svg"
            alt="Download on the App Store"
            className="h-12"
          />
        </a>
      </div>

      {/* Broadcaster Section */}
      <div className="mt-32 md:mt-40">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* Left side: Title, copy, and list */}
          <div className="flex-1 order-2 md:order-1">
            <div className="flex items-center gap-3 mb-4">
              <h2 className="font-serif-600 text-3xl text-black">Broadcaster</h2>
              <span className="px-3 py-1 bg-orange-100 text-orange-800 text-sm font-medium rounded-full">
                Coming Soon
              </span>
            </div>

            <p className="font-serif text-lg text-gray-700 mb-6">
              Turn your iPhone into a broadcasting studio. Create your own radio
              station and share audio live with listeners worldwide.
            </p>

            <ul className="font-serif text-lg leading-relaxed space-y-4 text-gray-800">
              <li className="flex items-start">
                <div>
                  <strong>Broadcast anywhere</strong> — Go live from coffee shops,
                  concerts, or your commute. No studio required.
                </div>
              </li>
              <li className="flex items-start">
                <div>
                  <strong>Instant setup</strong> — Launch a station in seconds.
                  No computer, no complicated software.
                </div>
              </li>
              <li className="flex items-start">
                <div>
                  <strong>Share what matters</strong> — Stream music, conversations,
                  or ambient audio. Your content, your way.
                </div>
              </li>
            </ul>
          </div>

          {/* Right side: Image */}
          <div className="flex-1 order-1 md:order-2 flex justify-center">
            <img
              src="/images/iphone-broadcaster.avif"
              alt="iPhone showing Macrowave broadcaster interface"
              className="w-auto h-[400px] md:h-[500px] rounded-2xl"
            />
          </div>
        </div>
      </div>

      {/* Receiver Section */}
      <div className="mt-32 md:mt-40">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          {/* Left side: Image */}
          <div className="flex-1 order-1 flex justify-center">
            <img
              src="/images/iphone-receiver.webp"
              alt="iPhone showing Macrowave receiver interface with audio visualizer"
              className="w-auto h-[400px] md:h-[500px] rounded-2xl"
            />
          </div>

          {/* Right side: Title, copy, and list */}
          <div className="flex-1 order-2">
            <h2 className="font-serif-600 text-3xl text-black mb-4">Receiver</h2>

            <p className="font-serif text-lg text-gray-700 mb-6">
              Tune into live radio stations and discover what people are
              broadcasting. Tune in, follow stations, and get notified
              when your favorites go on air.
            </p>

            <ul className="font-serif text-lg leading-relaxed space-y-4 text-gray-800">
              <li className="flex items-start">
                <div>
                  <strong>Tune in instantly</strong> — Browse stations and start
                  listening with a single tap. No account required.
                </div>
              </li>
              <li className="flex items-start">
                <div>
                  <strong>Follow your favorites</strong> — Get push notifications
                  when stations you follow go on air.
                </div>
              </li>
              <li className="flex items-start">
                <div>
                  <strong>Beautiful visualizer</strong> — Watch the audio come to
                  life with a real-time visual experience.
                </div>
              </li>
              <li className="flex items-start">
                <div>
                  <strong>Free forever</strong> — Listening is completely free. No
                  subscriptions, no paywalls.
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  );
}
